import angular from 'angular';
import 'core-js/fn/array/from';
import 'angular-ui-bootstrap';
import 'angular-hal';
import 'angular-sanitize';
import 'ui-select';
import phoneNumber from './phone-number/phone-number';
import ezresBontas from './ezresbontas/ezresbontas';
import addFocus from './addfocus/addfocus';
import floatNumberOnly from './floatnumberonly/floatnumberonly';
import capitalize from './capitalize/capitalize';
import choicesTemplate from './template/selectize/choices.pug';
import pagerTemplate from './template/pager/pager.pug';
import matchTemplate from './template/selectize/match.pug';
import toggleNavbar from '../modules/navbar/toggleNavbar';
import hirlevel from '../applications/hirlevel/hirlevel';
import keresoDoboz from '../applications/kereso/keresodoboz/keresodoboz';
import 'angular-scroll';
import './ios/ioskeyboardfix';

const MODULE_NAME = 'common';


angular.module('ui.bootstrap.pagination').config(function ($provide) {
	'ngInject';
	$provide.decorator('uibPaginationDirective', function ($delegate, $templateCache) {
		var directive = $delegate[0];
		directive.scope.getPageHref = '&';
		$templateCache.put('uib/template/pagination/pagination.html', pagerTemplate());
		return $delegate;
	});
}).factory('scrollInterceptor', ['$location', '$timeout', '$document', '$rootScope', function ($location, $timeout, $document, $rootScope) {
	return  {
		response: function (response) {
			if ($rootScope.scrollTimeoutPromise) {
				$timeout.cancel($rootScope.scrollTimeoutPromise);
			}
			let hash = $location.absUrl().split('#/');
			if (hash.length > 1) {
				let name = hash[hash.length - 1];
				let element = angular.element(document.querySelectorAll(`a[name='${name}']`));
				$rootScope.scrollTimeoutPromise = $timeout(function () {
					$document.scrollToElement(element);
				}, 500);
			}
			return response;
		}
	};
}]).config(['$httpProvider', function ($httpProvider) {
	$httpProvider.interceptors.push('scrollInterceptor');
}]);

// eslint-disable-next-line max-len
export default angular.module(MODULE_NAME, ['ui.bootstrap', 'angular-hal', 'ngSanitize', 'ui.select', 'duScroll', toggleNavbar, ezresBontas, floatNumberOnly, capitalize, phoneNumber, hirlevel, keresoDoboz, addFocus]).run(function ($templateCache) {
	'ngInject';
	$templateCache.put('selectize/choices.tpl.html', choicesTemplate());
	$templateCache.put('selectize/match.tpl.html', matchTemplate());
}).name;



// WEBPACK FOOTER //
// ./source/common/common.js